/**
 * Convert possible hms string into milliseconds
 * @param {String} hms Possible hh:mm:ss string
 * @param {String} separator Separator for hms string
 */
export default function parseHMS(hms, separator = ":") {
  const asArray = hms
    ? hms
        .toString()
        .split(separator)
        .map(value => parseInt(value, 10))
    : [];
  asArray.reverse();
  return asArray.reduce((accumulator, currentValue, index) => {
    let seconds = 0;
    switch (index) {
      // Seconds
      case 0:
        seconds += currentValue;
        break;
      // Minutes
      case 1:
        seconds += currentValue * 60;
        break;
      // Hours
      case 2:
        seconds += currentValue * 60 * 60;
        break;
      default:
        break;
    }
    return accumulator + seconds;
  }, 0);
}
